// extracted by mini-css-extract-plugin
module.exports = {"theme-toggle":"ThemeToggle__theme-toggle__3rw9p"};